export function MedicalRecordReducer(state: any, action: any) {
    switch (action.type) {
        case 'setMedicalRecord':
            return {...state, medical_record: action.medical_record};
        case 'setLoading':
            return {...state, loading: action.loading};
        default:
            return state;
    }
}